export const catagory = [
  { name: "Desktop" },
  { name: "Laptop" },
  { name: "Iphone" },
  { name: "Tablet" },
];
